import React from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useFetchCommon } from '../../../../../../_metronic/helpers/crud-helper/useQuery'
import UploadImage from '../../../../../../_metronic/helpers/components/ImageUpload'
import { errorToast, successToast } from '../../../../../../_metronic/helpers/components/Toaster'
import { useGeolocated } from 'react-geolocated'

interface Item {
    itemId: any;
    itemName: any;
    price: any;
    quantity: string;
    packingUnit: string;
}
interface TryModalProps {
    onClose?: () => void
}

const TryModal = ({ onClose }: TryModalProps) => {
    const [items, setItems] = React.useState<Item[]>([])
    const [pricingInfo, setPricingInfo] = React.useState(true)
    const [wasteSourceId, setWasteSourceId] = React.useState('')
    const [customerId, setCustomerId] = React.useState('')
    const [userId, setUserId] = React.useState('')
    const [latitude, setLatitude] = React.useState<number | null>(null)
    const [longitude, setLongitude] = React.useState<number | null>(null)
    const [locationLoading, setLocationLoading] = React.useState(true)
    const [batchManagement, setBatchManagement] = React.useState<'AUTO' | 'MANUAL'>('AUTO')
    const [locationPermission, setLocationPermission] = React.useState<'prompt' | 'granted' | 'denied'>('prompt')
    const [showLocationModal, setShowLocationModal] = React.useState(false)
    const [franchiseId, setFranchiseId] = React.useState('')
    const [uploadedImages, setUploadedImages] = React.useState<string[]>([])
    const [mandatoryImagesCount, setMandatoryImagesCount] = React.useState(1)
    const [addRemarks, setAddRemarks] = React.useState(true)
    const [paymentRecord, setPaymentRecord] = React.useState(true)
    const [selectedCustomerData, setSelectedCustomerData] = React.useState<any>(null)
    const [routeData, setRouteData] = React.useState<any>(null)
    const [routeLength, setRouteLength] = React.useState('')
    const [franchiseLocation, setFranchiseLocation] = React.useState<{ lat: number, lng: number } | null>(null)
    const [rating, setRating] = React.useState(0)


    const formik = useFormik({
        initialValues: {
            customer: '',
            category: '',
            collectionDate: '',
            collectionLocation: '',
            characteristics: '',
            remarks: '',
            paymentType: '',
            image0: '',
            image1: '',
            image2: '',
        },
        // validationSchema: Yup.object().shape({
        //     customer: Yup.string().required('Required'),
        //     category: Yup.string().required('Required'),
        //     collectionDate: Yup.string().required('Required'),
        //     collectionLocation: Yup.string().required('Required'),
        //     paymentType: Yup.string().required('Required'),
        // }),
        validationSchema: Yup.object().shape({
            customer: Yup.string().required('Required'),
            category: Yup.string().required('Required'),
            collectionDate: Yup.string().required('Required'),
            // collectionLocation: Yup.string().required('Required'),
            // paymentType: Yup.string().required('Required'),
            paymentType: paymentRecord ? Yup.string().required('Required') : Yup.string(),
            image0: mandatoryImagesCount >= 1 ? Yup.string().required('Image 1 is required') : Yup.string(),
            image1: mandatoryImagesCount >= 2 ? Yup.string().required('Image 2 is required') : Yup.string(),
            image2: mandatoryImagesCount >= 3 ? Yup.string().required('Image 3 is required') : Yup.string(),
        }),
        onSubmit: async (values) => {
            // console.log('=== FORM SUBMITTED ===')
            // console.log('Values:', values)
            // console.log('CustomerId:', customerId)
            // console.log('UserId:', userId)
            // console.log('Items:', items)

            // Collect uploaded images from formik values
            const images = [
                values.image0,
                values.image1,
                values.image2
            ].filter(img => img) // Remove empty values
            if (images.length < mandatoryImagesCount) {
                errorToast(`Please upload at least ${mandatoryImagesCount} image(s)`)
                return
            }

            // Validate mandatory images
            // if (images.length < mandatoryImagesCount) {
            //     alert(`Please upload at least ${mandatoryImagesCount} image(s)`)
            //     return
            // }

            // Filter items that have quantity entered
            const itemsWithQuantity = items.filter(item => item.quantity && parseFloat(item.quantity) > 0)

            // // Validate at least one item
            // if (itemsWithQuantity.length === 0) {
            //     alert('Please add at least one item with quantity')
            //     return
            // }

            // Get full item objects from itemsData
            const data = itemsWithQuantity.length > 0 ? [{
                categoryId: formik.values.category,
                items: itemsWithQuantity.map(item => {
                    const fullItemData = itemsData?.find(dataItem => dataItem.id === item.itemId)
                    return {
                        ...fullItemData,
                        itemId: item.itemId,
                        price: parseFloat(item.price) || 0,
                        quantity: parseFloat(item.quantity) || 0,
                        packingUnit: item.packingUnit || '1',
                    }
                })
            }] : []

            const totalAmount = itemsWithQuantity.reduce((sum, item) => {
                return sum + (parseFloat(item.price) || 0) * (parseFloat(item.quantity) || 0)
            }, 0)

            const collectionDateEpoch = Date.now()

            // Convert to MM/DD/YYYY format
            const actualCollectionDate = values.collectionDate
                ? (() => {
                    const date = new Date(values.collectionDate)
                    const month = String(date.getMonth() + 1).padStart(2, '0')
                    const day = String(date.getDate()).padStart(2, '0')
                    const year = date.getFullYear()
                    return `${day}/${month}/${year}`
                })()
                : ''

            const specialCharacteristics: string[] = []
            if (selectedChar1) specialCharacteristics.push(selectedChar1)
            if (selectedChar2) specialCharacteristics.push(selectedChar2)
            const { image0, image1, image2, paymentType, ...restValues } = values
            const cleanedValues = Object.keys(restValues).reduce((acc, key) => {
                if (!key.includes('_type')) {
                    acc[key] = restValues[key]
                }
                return acc
            }, {} as any)

            const finalData = {
                customerId: customerId,
                userId: userId,
                data: data,
                ...cleanedValues,
                orderType: "COLLECT",
                source: "Corporate",
                totalAmount: totalAmount,
                images: images,
                collectionDate: collectionDateEpoch,
                actualCollectionDate: actualCollectionDate,
                wasteSourceId: wasteSourceId,
                latitude: latitude,
                longitude: longitude,
                specialCharacteristics: specialCharacteristics,
                paymentMode: values.paymentType || "CASH",
                routeLength: routeLength || null,
                transportId: "6870b82d850b7ee652f78d5f",
                rating: rating
            }
            // console.log('Final payload:', finalData)

            // Get headers from localStorage
            // Get headers from localStorage
            const getHeaders = (): Record<string, string> => {
                const authData = localStorage.getItem('kt-auth-react-v')
                if (authData) {
                    const parsedData = JSON.parse(authData)
                    return {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'franchiseeid': parsedData?.data?.franchiseId || '',
                        'pickuppointid': parsedData?.data?.pickuppointid || '',
                        'authorization': parsedData?.data?.token || '',
                        'app-id': '3',
                        'client-id': '101212'
                    }
                }
                return {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'franchiseeid': '',
                    'pickuppointid': '',
                    'authorization': '',
                    'app-id': '3',
                    'client-id': '101212'
                }
            }

            // Call API
            try {
                formik.setSubmitting(true)

                const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}order`, {
                    method: 'POST',
                    headers: getHeaders(),
                    body: JSON.stringify(finalData)
                })

                const result = await response.json()

                if (response.ok) {
                    successToast('Order created successfully!')
                    formik.resetForm()
                    setItems([])
                    setSelectedChar1('')
                    setSelectedChar2('')
                    setSelectedPaymentType('')
                    setRating(0)
                    setRouteLength('')
                    onClose?.()
                    // setTimeout(() => {
                    //     window.location.reload()
                    // }, 500) 
                } else {
                    errorToast(result.message || 'Failed to create order')
                }
            } catch (error) {
                errorToast('Failed to create order. Please try again.')
            } finally {
                formik.setSubmitting(false)
            }
        },
    })

    const { responseData, isFetching } = useFetchCommon({
        api: 'users?type=CUSTOMER',
        isDropDown: true,
        label: ['personalDetails', 'name'],
        isEnabled: true,
    })

    const { responseData: categoriesData, isFetching: isFetchingCategories } = useFetchCommon({
        api: 'clients/101212/categories?page=0&size=10',
        isDropDown: true,
        label: ['name'],
        isEnabled: true,
    })

    const { responseData: itemsData, isFetching: isFetchingItems } = useFetchCommon({
        api: `categories/${formik.values.category}/items?page=0&size=10`,
        isDropDown: false,
        isEnabled: !!formik.values.category,
    })
    const { responseData: priceData, isFetching: isFetchingPrices } = useFetchCommon({
        api: `categories/${formik.values.category}/price`,
        isDropDown: false,
        isEnabled: !!formik.values.category,
    })
    const { responseData: locationData, isFetching: isFetchingLocations } = useFetchCommon({
        api: 'users?type=WASTE_SOURCE',
        isDropDown: true,
        label: ['personalDetails', 'name'],
        isEnabled: true,
    })
    const { responseData: franchiseData, isFetching: isFetchingFranchise } = useFetchCommon({
        api: `users/${franchiseId}`,
        isDropDown: false,
        isEnabled: !!franchiseId,
    })

    React.useEffect(() => {
        if (franchiseData) {
            // console.log('Franchise data:', franchiseData)
            const management = franchiseData?.customSettings?.preferences?.batchManagement || 'AUTO'
            const mandatoryCount = parseInt(franchiseData?.customSettings?.preferences?.mandatoryImages || '1')
            const showRemarks = franchiseData?.customSettings?.preferences?.addRemarks || false
            const editablePrice = franchiseData?.customSettings?.preferences?.pricingInfo || false
            const showPayment = franchiseData?.customSettings?.preferences?.paymentRecord || false

            setBatchManagement(management)
            setMandatoryImagesCount(mandatoryCount)
            setAddRemarks(showRemarks)
            setPricingInfo(editablePrice)
            setPaymentRecord(showPayment)

            // Get franchise location
            const franchiseLat = franchiseData?.address?.latitute
            const franchiseLng = franchiseData?.address?.longitute
            if (franchiseLat && franchiseLng) {
                setFranchiseLocation({ lat: franchiseLat, lng: franchiseLng })
            }

            // console.log('Batch Management:', management)
            // console.log('Mandatory Images:', mandatoryCount)
            // console.log('Add Remarks:', showRemarks)
            // console.log('Pricing Info:', editablePrice)
            // console.log('Payment Record:', showPayment)
            // console.log('Franchise Location:', franchiseLat, franchiseLng)
        }
    }, [franchiseData])


    const fetchRoute = async (customerLat: number, customerLng: number) => {
        if (!franchiseLocation) {
            // console.error('Franchise location not available')
            return
        }

        try {
            const response = await fetch(
                `https://maps.googleapis.com/maps/api/directions/json?origin=${customerLat},${customerLng}&destination=${franchiseLocation.lat},${franchiseLocation.lng}&key=AIzaSyD32soTrhrAXzmKQp7rH8NsL8NQMhmdqlY&mode=driving`
            )
            const data = await response.json()

            if (data.status === 'OK' && data.routes && data.routes.length > 0) {
                const route = data.routes[0]
                const distance = route.legs[0].distance.text
                setRouteLength(distance)
                setRouteData(data)
                // console.log('Route data:', data)
                // console.log('Distance:', distance)
            } else {
                console.error('Route not found:', data.status)
            }
        } catch (error) {
            console.error('Error fetching route:', error)
        }
    }


    React.useEffect(() => {
        if (itemsData && Array.isArray(itemsData) && itemsData.length > 0) {
            const mappedItems = itemsData.map(item => {
                const itemPrice = priceData?.find(price => price.itemId === item.id)

                return {
                    itemId: item.id,
                    itemName: item.displayName || item.name,
                    price: itemPrice?.price || '',
                    quantity: '',
                    packingUnit: '1'
                }
            })
            setItems(mappedItems)
        } else {
            setItems([])
        }
    }, [itemsData, priceData])
    //getting user id from the local storage
    React.useEffect(() => {
        const authData = localStorage.getItem('kt-auth-react-v')
        if (authData) {
            try {
                const parsedData = JSON.parse(authData)
                const userIdFromStorage = parsedData?.data?.userId || ''
                const franchiseIdFromStorage = parsedData?.data?.franchiseId || ''

                setUserId(userIdFromStorage)
                setFranchiseId(franchiseIdFromStorage)

                // console.log('UserId from localStorage:', userIdFromStorage)
                // console.log('FranchiseId from localStorage:', franchiseIdFromStorage)
            } catch (error) {
                console.error('Error parsing auth data:', error)
            }
        }
    }, [])

    const getFirstDayOfMonth = () => {
        const today = new Date()
        const firstDay = new Date(today.getFullYear(), today.getMonth(), 1)
        return firstDay.toISOString().split('T')[0]
    }

    const getTodayDate = () => {
        return new Date().toISOString().split('T')[0]
    }

    // Reset items when category changes
    React.useEffect(() => {
        setItems([])
    }, [formik.values.category])

    const handleItemChange = (index: number, field: keyof Item, value: any) => {
        const updatedItems = [...items]
        updatedItems[index][field] = value
        setItems(updatedItems)
    }
    const [selectedPaymentType, setSelectedPaymentType] = React.useState('')

    const paymentTypes = [
        { id: 1, label: "Cash", value: "CASH" },
        { id: 2, label: "Bank Transfer", value: "BANK_TRANSFER" },
        { id: 3, label: "Donation", value: "DONATION" },
    ]


    const [selectedChar1, setSelectedChar1] = React.useState('')
    const [selectedChar2, setSelectedChar2] = React.useState('')

    const specialChar1 = [
        { id: 1, label: "PCR", value: "POST_CONSUMER" },
        { id: 2, label: "PIR", value: "POST_INDUSTRIAL" },
        { id: 3, label: "Virgin", value: "VIRGIN" },
    ]

    const specialChar2 = [
        { id: 1, label: "OBP", value: "OBP" },
        { id: 2, label: "ISCC", value: "ISCC" },
        { id: 3, label: "VERRA", value: "VERRA" },
    ]

    const inputStyle = 'form-control form-control-solid mb-3 mb-lg-0'
    const customInputStyle = {
        backgroundColor: 'white',
        border: '1px solid #d1d5db',
        borderRadius: '0.475rem',
    }


    React.useEffect(() => {
        if (!navigator.geolocation) {
            console.error('Geolocation is not supported by this browser')
            setLocationLoading(false)
            errorToast('Your browser does not support location services')
            return
        }

        console.log('Requesting GPS location...')

        navigator.geolocation.getCurrentPosition(
            (position) => {
                setLatitude(position.coords.latitude)
                setLongitude(position.coords.longitude)
                setLocationLoading(false)
                console.log('✅ GPS Location:', position.coords.latitude, position.coords.longitude)
            },
            (error) => {
                console.error('❌ GPS failed:', error.message)
                setLocationLoading(false)

                // Handle different error types
                if (error.code === error.PERMISSION_DENIED) {
                    errorToast('Location permission denied. Please enable location access in your browser settings.')
                } else if (error.code === error.POSITION_UNAVAILABLE) {
                    errorToast('Location information is unavailable. Please check your device settings.')
                } else if (error.code === error.TIMEOUT) {
                    errorToast('Location request timed out. Please try again.')
                }
            },
            {
                enableHighAccuracy: true, // Use GPS for best accuracy
                timeout: 15000, // Wait up to 15 seconds
                maximumAge: 0 // Don't use cached location, get fresh coordinates
            }
        )
    }, [])

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className='mb-4'>
                <label className='required fw-bold fs-6 mb-2'>Select Supplier</label>
                <select
                    className={inputStyle}
                    style={customInputStyle}
                    name='customer'
                    value={formik.values.customer}
                    onBlur={formik.handleBlur}
                    onChange={(e) => {
                        formik.setFieldValue('customer', e.target.value)
                        setCustomerId(e.target.value)
                        const customer = responseData?.find(cust => cust.value === e.target.value)
                        setSelectedCustomerData(customer?.data || null)
                        // console.log('Selected customer data:', customer?.data)
                        const customerLat = customer?.data?.address?.latitute
                        const customerLng = customer?.data?.address?.longitute
                        if (customerLat && customerLng && franchiseLocation) {
                            fetchRoute(customerLat, customerLng)
                        }
                    }}
                >
                    <option value=''>Select</option>
                    {isFetching ? (
                        <option disabled>Loading...</option>
                    ) : (
                        responseData?.map((customer) => (
                            <option key={customer.value} value={customer.value}>
                                {customer.label}
                            </option>
                        ))
                    )}
                </select>
            </div>

            <div className='mb-4'>
                <label className='required fw-bold fs-6 mb-2'>Select category</label>
                <select
                    className={inputStyle}
                    style={customInputStyle}
                    {...formik.getFieldProps('category')}
                >
                    <option value=''>Select</option>
                    {isFetchingCategories ? (
                        <option disabled>Loading...</option>
                    ) : (
                        categoriesData?.map((category) => (
                            <option key={category.value} value={category.value}>
                                {category.label}
                            </option>
                        ))
                    )}
                </select>
            </div>

            {/* Items Section - Shows only when category is selected */}
            {formik.values.category && (
                <div className='mb-4'>
                    <label className='fw-bold fs-6 mb-3'>Items</label>
                    {isFetchingItems ? (
                        <div className='text-center py-4'>
                            <span className='spinner-border spinner-border-sm me-2'></span>
                            Loading items...
                        </div>
                    ) : items.length > 0 ? (
                        <>
                            {/* Header Row */}
                            <div className='row mb-2'>
                                <div className={batchManagement === 'MANUAL' ? 'col-md-3' : 'col-md-4'}>
                                    <strong>Item name</strong>
                                </div>
                                <div className={batchManagement === 'MANUAL' ? 'col-md-3' : 'col-md-4'}>
                                    <strong>Price</strong>
                                </div>
                                <div className={batchManagement === 'MANUAL' ? 'col-md-3' : 'col-md-4'}>
                                    <strong>Quantity</strong>
                                </div>
                                {batchManagement === 'MANUAL' && (
                                    <div className='col-md-3'>
                                        <strong>Packing Unit</strong>
                                    </div>
                                )}
                            </div>

                            {/* Item Rows */}
                            {items.map((item, index) => (
                                <div key={item.itemId} className='row mb-3'>
                                    <div className={batchManagement === 'MANUAL' ? 'col-md-3' : 'col-md-4'}>
                                        <input
                                            type='text'
                                            className={inputStyle}
                                            value={item.itemName}
                                            readOnly
                                        />
                                    </div>
                                    <div className={batchManagement === 'MANUAL' ? 'col-md-3' : 'col-md-4'}>
                                        <input
                                            type='number'
                                            className={inputStyle}
                                            style={customInputStyle}
                                            value={item.price}
                                            onChange={(e) => handleItemChange(index, 'price', e.target.value)}
                                            placeholder='Enter price'
                                            min="0"
                                            readOnly={!pricingInfo}
                                            disabled={!pricingInfo}
                                        />
                                    </div>
                                    <div className={batchManagement === 'MANUAL' ? 'col-md-3' : 'col-md-4'}>
                                        <input
                                            type='number'
                                            step='0.01'
                                            className={inputStyle}
                                            style={customInputStyle}
                                            value={item.quantity}
                                            onChange={(e) => {
                                                const value = e.target.value
                                                if (value === '' || parseFloat(value) >= 0) {
                                                    handleItemChange(index, 'quantity', value)
                                                }
                                            }}
                                            onBlur={(e) => {
                                                const value = parseFloat(e.target.value)
                                                if (!isNaN(value) && value >= 0) {
                                                    handleItemChange(index, 'quantity', value.toFixed(2))
                                                } else if (value < 0) {
                                                    handleItemChange(index, 'quantity', '0')
                                                }
                                            }}
                                            placeholder='Enter quantity'
                                            min="0"
                                        />
                                    </div>
                                    {batchManagement === 'MANUAL' && (
                                        <div className='col-md-3'>
                                            <input
                                                type='number'
                                                className={inputStyle}
                                                style={customInputStyle}
                                                value={item.packingUnit}
                                                onChange={(e) => handleItemChange(index, 'packingUnit', e.target.value)}
                                                placeholder='Enter packing unit'
                                                min="1"
                                            />
                                        </div>
                                    )}
                                </div>
                            ))}
                        </>
                    ) : (
                        <div className='text-center py-4 text-dark'>
                            No items available for this category
                        </div>
                    )}
                </div>
            )}

            <div className='row mb-4'>
                <div className='col-md-6'>
                    <label className='required fw-bold fs-6 mb-2'>Actual Collection date</label>
                    <input
                        type='date'
                        className={inputStyle}
                        style={customInputStyle}
                        {...formik.getFieldProps('collectionDate')}
                        min={getFirstDayOfMonth()}
                        max={getTodayDate()}
                    />
                </div>
                <div className='col-md-6'>
                    <label className='fw-bold fs-6 mb-2'>Collection Location (Optional)</label>
                    <select
                        className={inputStyle}
                        style={customInputStyle}
                        name='collectionLocation'
                        value={formik.values.collectionLocation}
                        onBlur={formik.handleBlur}
                        onChange={(e) => {
                            formik.setFieldValue('collectionLocation', e.target.value)
                            setWasteSourceId(e.target.value)
                        }}
                    >
                        <option value=''>Select</option>
                        {isFetchingLocations ? (
                            <option disabled>Loading...</option>
                        ) : (
                            locationData?.map((location) => (
                                <option key={location.value} value={location.value}>
                                    {location.label}
                                </option>
                            ))
                        )}
                    </select>
                </div>
            </div>

            <div className='mb-4'>
                <label className='fw-bold fs-6 mb-2'>Special Characteristics</label>

                {/* First Row - PCR/PIR/Virgin */}
                <div className='d-flex gap-2 mb-2'>
                    {specialChar1.map((char) => (
                        <button
                            key={char.id}
                            type='button'
                            onClick={() => setSelectedChar1(char.value)}
                            style={{
                                backgroundColor: selectedChar1 === char.value ? '#393945' : 'white',
                                color: selectedChar1 === char.value ? 'white' : '#393945',
                                border: '1px solid #393945',
                                borderRadius: '0.475rem',
                                padding: '8px 16px',
                                cursor: 'pointer',
                                transition: 'all 0.3s'
                            }}
                        >
                            {char.label}
                        </button>
                    ))}
                </div>

                {/* Second Row - OBP/ISCC/VERRA */}
                <div className='d-flex gap-2'>
                    {specialChar2.map((char) => {
                        const isISCC = char.value === 'ISCC'
                        const isDisabled = isISCC && selectedCustomerData && !selectedCustomerData.isccEuCertificate

                        return (
                            <button
                                key={char.id}
                                type='button'
                                onClick={() => {
                                    if (!isDisabled) {
                                        setSelectedChar2(char.value)
                                    }
                                }}
                                disabled={isDisabled}
                                style={{
                                    backgroundColor: selectedChar2 === char.value ? '#393945' : 'white',
                                    color: selectedChar2 === char.value ? 'white' : '#393945',
                                    border: '1px solid #393945',
                                    borderRadius: '0.475rem',
                                    padding: '8px 16px',
                                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                                    opacity: isDisabled ? 0.5 : 1,
                                    transition: 'all 0.3s'
                                }}
                            >
                                {char.label}
                            </button>
                        )
                    })}
                </div>
            </div>



            {paymentRecord && (
                <div className='mb-4'>
                    <label className='required fw-bold fs-6 mb-2'>Select Payment Type</label>
                    <div className='d-flex gap-2'>
                        {paymentTypes.map((payment) => (
                            <button
                                key={payment.id}
                                type='button'
                                onClick={() => {
                                    setSelectedPaymentType(payment.value)
                                    formik.setFieldValue('paymentType', payment.value)
                                }}
                                style={{
                                    backgroundColor: selectedPaymentType === payment.value ? '#393945' : 'white',
                                    color: selectedPaymentType === payment.value ? 'white' : '#393945',
                                    border: '1px solid #393945',
                                    borderRadius: '0.475rem',
                                    padding: '8px 16px',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s'
                                }}
                            >
                                {payment.label}
                            </button>
                        ))}
                    </div>
                </div>
            )}



            {addRemarks && (
                <div className='mb-4'>
                    <label className='fw-bold fs-6 mb-2'>Remarks</label>
                    <textarea
                        rows={2}
                        className={inputStyle}
                        style={customInputStyle}
                        {...formik.getFieldProps('remarks')}
                        placeholder='Enter remarks...'
                    />
                </div>
            )}


            <div className='mb-4'>
                <label className='fw-bold fs-6 mb-2'>
                    Upload Images
                    <span className='text-danger ms-1'>({mandatoryImagesCount} required, max 3)</span>
                </label>

                <div className='row'>
                    {[0, 1, 2].map((index) => (
                        <div key={index} className='col-md-4 mb-3'>
                            <UploadImage
                                name={`image${index}`}
                                formik={formik}
                                label={index < mandatoryImagesCount ? `Image ${index + 1} (Required)` : `Image ${index + 1} (Optional)`}
                                required={index < mandatoryImagesCount}
                            />
                        </div>
                    ))}
                </div>
            </div>



            <div className='mb-4'>
                <label className='fw-bold fs-6 mb-2'>Rating</label>
                <div className='d-flex gap-2'>
                    {[1, 2, 3, 4, 5].map((star) => (
                        <button
                            key={star}
                            type='button'
                            onClick={() => setRating(star)}
                            style={{
                                fontSize: '32px',
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                color: star <= rating ? '#ffc107' : '#e0e0e0',
                                transition: 'color 0.2s'
                            }}
                        >
                            ★
                        </button>
                    ))}
                </div>
            </div>




            <div className='text-center pt-10'>
                <button
                    type='submit'
                    className='btn btn-primary'
                // onClick={() => console.log('Button clicked!')}
                >
                    <span className='indicator-label'>Submit</span>
                    {formik.isSubmitting && (
                        <span className='indicator-progress'>
                            Please wait...
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                    )}
                </button>
            </div>
        </form>
    )
}

export default TryModal